import { AxiosResponse } from "axios";
import api from "./client";

// Consent timeline / audit trail (per consent)
export const getConsentLedger = (
  consent_id: string,
  tenant_id: string,
  notice_version?: string,
): Promise<AxiosResponse> =>
  api.get("/admin/consent-ledger", { params: { consent_id, tenant_id, notice_version } });
